import React from 'react';
import {get, mapKeys} from 'lodash';
import axios from 'axios';
import Waypoint from 'react-waypoint';

import {
  metaLoading,
} from '../lib/helpers';

import Loading from './Loading';

class PosmoniLogsTable extends React.Component {
  state = {
    ...metaLoading,
    shouldFetch: true,
    logs: []
  }

  viewAllUrl = () => {
    const queryParams = mapKeys(get(this.props, 'queryParams', {}), (v, k)=> (`query[${k}]`))
    return `/${gon.currentProvider}/${this.props.modelName}/search?${new URLSearchParams(queryParams).toString()}`
  }

  fetchData = () => {
    if (this.state.shouldFetch) {
      axios.get(`/${gon.currentProvider}/api/${this.props.modelName}`, { params: get(this.props, 'queryParams') }).then((res) => {
        if (res.status == 200 && get(res, 'data')) {
          this.setState({
            logs: res.data['logs'],
            shouldFetch: false,
            meta: {
              isLoading: false
            },
          })
        }
      })
    }
  }

  componentDidMount() {
    this.setState({
      meta: {
        isLoading: true,
      },
    })
  }

  render() {
    return (
      <React.Fragment>
        <div className='User__header'>
          <h3 className='User__header__h3'>{this.props.title}</h3>
        </div>

        <Waypoint onEnter={this.fetchData}>
          <div className='Table__wrapper'>
            <Loading
              isLoading={get(this.state, 'meta.isLoading') && get(this.state, 'logs.length', 0) == 0}
            >
              <div className='Table' style={{gridTemplateColumns: Array(get(this.props, 'columns.length', 0)).fill('1fr').join(' ')}}>
                <div className='Table__row'>
                  {get(this.props, 'columns', []).map((text) => (
                    <div key={text} className='Table__col Table__col--th'>{text}</div>
                  ))}

                </div>

                {get(this.state, 'logs', []).map(this.props.rowComponent)}
              </div>
            </Loading>

            {get(this.state, 'logs', []).length > 0 &&
              <a
                className='Table__view-all'
                href={this.viewAllUrl()}
                target='_blank'
              >
                View all
              </a>
            }
          </div>
        </Waypoint>
      </React.Fragment>
    );
  }
}

export default PosmoniLogsTable
